export const formatUsersList = (usersList) => {
  return usersList.map((user) => ({
    id: user.id,
    name: `${user.first_name} ${user.last_name}`,
  }));
};
